import { Alert, Group, Modal, Stack, Text } from '@mantine/core';
import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useCancelAuthorisedSignatory } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useCancelAuthorisedSignatory';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
	signatureId: string;
	signatoryName: string;
	opened: boolean;
	onClose: () => void;
}

export const CancelAuthorisedSignatoryModal = ({
	dealId,
	programmeId,
	documentWorkflowInstanceId,
	signatureId,
	signatoryName,
	opened,
	onClose,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const { cancel, isPending } = useCancelAuthorisedSignatory({
		dealId,
		programmeId,
		documentWorkflowInstanceId,
		onSuccess: onClose,
	});

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			closeOnClickOutside={false}
			size="lg"
			padding="md"
			radius="md"
			withCloseButton
			centered
			title={
				<Text size="18px" fw={600}>
					{tMipManage('documents_page.cancel_authorised_signatory.modal.title')}
				</Text>
			}
			styles={{
				body: { backgroundColor: '#fff' },
				header: { backgroundColor: '#fff', marginBottom: 0 },
				content: { backgroundColor: '#fff' },
			}}
		>
			<Stack gap="sm">
				<Alert
					color="orange"
					variant="light"
					radius="sm"
					icon={<Icon variant="warning" size="lg" />}
				>
					<Text size="13px" c="gray.8">
						{tMipManage('documents_page.cancel_authorised_signatory.modal.warning', {
							name: signatoryName,
						})}
					</Text>
				</Alert>

				<Group justify="right" gap="xs">
					<ButtonV2
						size="s"
						buttonTheme="light"
						variant="tertiary"
						onClick={onClose}
						disabled={isPending}
					>
						{tMipManage('documents_page.cancel_authorised_signatory.modal.keep')}
					</ButtonV2>
					<ButtonV2
						size="s"
						buttonTheme="light"
						variant="primary"
						disabled={isPending}
						onClick={() => cancel(signatureId)}
						data-testid={TEST_ELEMENT_IDS.CANCEL_AUTHORISED_SIGNATORY_CONFIRM_BUTTON}
					>
						{tMipManage('documents_page.cancel_authorised_signatory.modal.confirm')}
					</ButtonV2>
				</Group>
			</Stack>
		</Modal>
	);
};
